export default function formatDate(date) {
  return date.toISOString().slice(0, 10);
}

export const diffInMonths = (end, start) => {
  var timeDiff = Math.abs(end.getTime() - start.getTime());
  return Math.floor(timeDiff / (2e3 * 3600 * 365.25));
}